function defaultState() {
    return {
        refresh: 0
    };
}

const state = defaultState();

const getters = {
    refresh: state => {
        return state.refresh;
    }
};

const mutations = {
    resetState(state) {
        state = defaultState();
    },
    setRefresh(state, payload) {
        state.refresh = payload;
    }
};

const actions = {
    reset({ commit }) {
        commit("resetState");
    },
    setRefresh({ commit }, payload) {
        commit("setRefresh", payload);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
